<div class="cbta-web-container flex h-svh h-dvh w-full flex-col overflow-hidden md:w-auto">
	<div class="main-section flex min-h-0 w-full flex-1 flex-col overflow-hidden">
		<!-- Navbar -->
		<app-header class="relative z-[99] block shrink-0"></app-header>
		<div class="flex min-h-0 flex-1 flex-row overflow-hidden">
			<app-sidebar></app-sidebar>
			<!-- cbta-web pages -->
			<div id="cbta-web-page-container" class="cbta-web-page-container min-h-0 flex-1 overflow-auto bg-white">
				<router-outlet></router-outlet>
			</div>
		</div>

		<!-- Footer (desktop only; tablet uses the bottom sidebar) -->
		<app-footer class="block shrink-0"></app-footer>
	</div>
</div>
<!-- setup profile modal -->
@if (showProfileSetup) {
	<div class="fixed left-0 top-0 z-[100] flex h-full w-full items-center justify-center bg-black bg-opacity-30">
		<div class="w-full max-w-sm rounded-md border bg-white p-6 shadow-lg">
			<div class="mb-6 text-sm text-grey-60">Setup Profile</div>
			<div class="mb-8">Let's get your profile set up to begin.</div>
			<button (click)="goToProfile()" class="aa-btn ml-auto" data-size="small" data-variant="secondary">
				Go to Profile
			</button>
		</div>
	</div>
}
